import React from 'react';
import pt from 'prop-types';
import { Box } from '@mui/material';

// Rounded pill search matching the content tab's search box, shared by the
// dashboard viewers card and the Viewers tab so they look/behave identically.
const PillSearch = ({
  value, onChange, placeholder, minWidth,
}) => (
  <Box sx={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    height: 37,
    px: '12px',
    boxSizing: 'border-box',
    flexShrink: 0,
    background: '#fff',
    border: '1px solid #d0d5dd',
    borderRadius: '999px',
    minWidth,
    transition: 'border-color 0.15s ease',
    '&:focus-within': { borderColor: '#15171c' },
  }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#98a2b3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      style={{
        flex: 1,
        minWidth: 0,
        border: 'none',
        outline: 'none',
        background: 'transparent',
        fontFamily: '"Montserrat", sans-serif',
        fontSize: 13,
        fontWeight: 500,
        color: '#15171c',
      }}
    />
  </Box>
);

PillSearch.propTypes = {
  value: pt.string.isRequired,
  onChange: pt.func.isRequired,
  placeholder: pt.string,
  minWidth: pt.oneOfType([pt.number, pt.string]),
};

PillSearch.defaultProps = {
  placeholder: 'Search',
  minWidth: 200,
};

export default PillSearch;
